module.exports = __webpack_public_path__ + "img/team1.81a19f6b.webp";